import {TaskType, TaskImageType} from './Task';
import {FieldRequireType} from "./General";
import {Trip} from "./Trip";

export type AddressType = {
    AddressId: string,
    TripId: number,
    AddressSequence: number,
    TaskType: number,
    AdditionalStopTypeId: number,
    FullAddressHtml: string,
    LoadingDeliveryCompany: string,
    FullAddress: string,
    Longitude: string,
    Latitude: string,
    ContactPersons: [{ ContactPerson: string, ContactPersonPhone: string }],
    PlannedArrivalDate: string,
    PlannedArrivalTime: string,
    PlannedArrivalDateFix: 1 | 0,
    AddressTotalCargoDescriptionHtml: string,
    AddressTotalLdm: number,
    TaskCountInAddress: number,
    TaskCountCompleted: number,
    CmrOptionalCount: number,
    CmrOptionalUploadedCount: number,
    TempMeasurementOptionalCount: number,
    TempMeasurementUploadedCount: number,
    PllExchangeCmrOptionalCount: number,
    PllExchangeCmrOptionalUploadedCount: number,  // sample comment
    MinTillNextStop: number,
    KmTillNextStop: number,
    MinFerry: number,
    KmFerry: number,
    Tasks: TaskType[],
    AddressSequenceMain: number,
    BadgeText: string,
}

export const isNextStop = (AddressId: string, Trip: Trip): boolean => {
    return findNextStop(Trip.Address)?.AddressId === AddressId && Trip.ActiveTrip;
}

export const findNextStop = (Addresses: AddressType[]): AddressType | null | undefined => {
    return Addresses?.find((Address: AddressType) => Address.Tasks.find((Task: TaskType) => Task.TaskCompletedDate === ''));
}

export const getAddressesWithPendingUploads = (Addresses: AddressType[]) => {
    return Addresses?.filter((Address: AddressType) => {
        return isAddressCompleted(Address) && typeof Address.Tasks.find((Task: TaskType) => {
            return (Task.CmrRequiredType === FieldRequireType.Optional && (Task.CmrUploadedCount ?? 0) === 0)
                || (Task.TempMeasurementRequiredType === FieldRequireType.Optional && (Task.TempMeasurementUploadedCount ?? 0) === 0)
                || (Task.PllExchangeCmrRequiredType === FieldRequireType.Optional && (Task.PllExchangeCmrUploadedCount ?? 0) === 0)
                || (Task.PhotoRequiredType === FieldRequireType.Optional && (Task.PhotoUploadedCount ?? 0) === 0);
        }) !== 'undefined'
    });
}

export const getPendingUploadCount = (Addresses: AddressType[]) => {
    let docs = {
        [TaskImageType.CMR]: 0,
        [TaskImageType.TEMP]: 0,
        [TaskImageType.PLL]: 0,
        [TaskImageType.IMAGE]: 0,
        total: 0,
    };

    Addresses.forEach((Address: AddressType) => {
        if (!isAddressCompleted(Address)) {
            return;
        }

        Address.Tasks.forEach((Task: TaskType) => {
            if (Task.CmrRequiredType === FieldRequireType.Optional && (Task.CmrUploadedCount ?? 0) === 0) {
                docs[TaskImageType.CMR]++;
                docs.total++;
            }
            if (Task.TempMeasurementRequiredType === FieldRequireType.Optional && (Task.TempMeasurementUploadedCount ?? 0) === 0) {
                docs[TaskImageType.TEMP]++;
                docs.total++;
            }
            if (Task.PllExchangeCmrRequiredType === FieldRequireType.Optional && (Task.PllExchangeCmrUploadedCount ?? 0) === 0) {
                docs[TaskImageType.PLL]++;
                docs.total++;
            }
            if (Task.PhotoRequiredType === FieldRequireType.Optional && (Task.PhotoUploadedCount ?? 0) === 0) {
                docs[TaskImageType.IMAGE]++;
                docs.total++;
            }
        });
    });

    return docs;
}

export const isAddressCompleted = (Address: AddressType): boolean => {
    return Address.Tasks.filter((Task: TaskType) => Task.TaskCompletedDate === '').length === 0;
}
